module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.AddDialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.AddDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择中心/部门:",
      "label-width": "110px"
    }
  }, [_c('el-input', {
    staticClass: "formLength",
    attrs: {
      "readonly": ""
    },
    on: {
      "focus": _vm.chooseDept
    },
    model: {
      value: (_vm.query.d_name),
      callback: function($$v) {
        _vm.$set(_vm.query, "d_name", $$v)
      },
      expression: "query.d_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "员工姓名:",
      "label-width": "80px"
    }
  }, [_c('el-input', {
    staticClass: "formLength",
    model: {
      value: (_vm.query.userName),
      callback: function($$v) {
        _vm.$set(_vm.query, "userName", $$v)
      },
      expression: "query.userName"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": _vm.onQuerySubmit
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "delete2"
    },
    on: {
      "click": _vm.onQueryClean
    }
  }, [_vm._v("重置")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.lists,
      "element-loading-text": "拼命加载中",
      "border": "",
      "router": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "中心",
      "prop": "CompanyName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "部门",
      "prop": "d_name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "员工",
      "prop": "name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "btm-action",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "small": "",
      "current-page": _vm.pageIndex,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalSize * 1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "footer"
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])], 1)], 1)], 1), _vm._v(" "), _c('chooseDept', {
    ref: "refsChooseDept",
    on: {
      "deptData": _vm.getDeptData
    }
  }), _vm._v(" "), _c('setEmployeeArea', {
    ref: "refSetEmployeeArea",
    on: {
      "close": _vm.close
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-238fe84a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Agent/AddEmployee/components/addEmployeeDialog/index.vue
// module id = 1420
// module chunks = 1